/*eslint-disable*/
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Input,
  OnInit,
} from "@angular/core";
import {
  FormArray,
  FormControl,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { CabLoadingComponent } from "@shared/cab-loading/cab-loading.component";
import { CabTabComponent } from "@shared/cab-tab/cab-tab.component";
import { CabAutocompleteComponent } from "@shared/form/components/cab-autocomplete/cab-autocomplete.component";
import { CabButtonComponent } from "@shared/form/components/cab-button/cab-button.component";
import { CabInputComponent } from "@shared/form/components/cab-input/cab-input.component";
import {
  EFormFieldTypes,
  IFormFields,
} from "src/app/shared/form/basic/basic-form.interface";
import { DistrictService } from "@modules/geography/services/district.service";
import { RegionService } from "@modules/geography/services/region.service";
import { BasicEditForm } from "@shared/form/basic/basic-edit.form";
import { TranslateModule } from "@ngx-translate/core";
import { IDistrict } from "@modules/geography/models/districts.interface";
import { cadastrialValidator } from "@shared/form/components/cab-validators/cadastrial.validator";

@Component({
  selector: "app-edit-district-form",
  templateUrl: "../district-form.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CabAutocompleteComponent,
    CabTabComponent,
    CabInputComponent,
    CabButtonComponent,
    CabLoadingComponent,
    TranslateModule,
  ],
})
export class EditDistrictFormComponent extends BasicEditForm implements OnInit {
  _defaultService = inject(DistrictService);
  _regionService = inject(RegionService);

  @Input() item: IDistrict;

  formFields: IFormFields = {
    id: this.createFormField(null),
    regionId: this.createFormField(null, [Validators.required]),
    cadastralCode: this.createFormField(null, [cadastrialValidator()]),
    name: this.createFormField(
      null,
      [Validators.required, Validators.minLength(5)],
      EFormFieldTypes.TRANSLATE
    ),
  };

  ngOnInit() {
    this._defaultService.selectRowData(this.item);
    super.ngOnInit();
    this.form.addControl("soatos", this._fb.array([null]));
  }

  get soatos(): FormArray {
    return this.form.get("soatos") as FormArray;
  }

  addSoato() {
    this.soatos.push(new FormControl(null, Validators.required));
  }

  removeSoato(index: number) {
    this.soatos.removeAt(index);
  }

  patchResponseData(res: any) {
    this.form.patchValue(this.convertToFormData(this.formFields, res));

    this.soatos.clear();
    if (res.soatos && res.soatos.length) {
      res.soatos.forEach((value: string) => {
        this.soatos.push(this._fb.control(value));
      });
    } else {
      this.soatos.push(this._fb.control(null, Validators.required));
    }
  }

  convertToRequestData(formFields: IFormFields, formValue: any) {
    const data = super.convertToRequestData(formFields, formValue);
    data["soatos"] = this.form.get("soatos")?.value;
    return data;
  }
}
